import React, { useState, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import StyledModal from '../../tools/StyledModal';
import Chat from '../../../redux/containers/chat/Chat';


export default function ChatModal(props) {
  const { open, handleClose, onConfirmationComplete, title, selectedUsersId } = props;

  const overrideStyles = {
    position: 'fixed',
    maxWidth: { xs: '100%', md: '100%', lg: '100%' },
    borderRadius: '0.5rem',
    boxShadow: 24,
    maxHeight: '94vh',
    overflowY: 'scroll',
    backgroundColor: 'white',
  };

  return (
    <StyledModal
      open={open}
      disableTitle={true}
      handleClose={handleClose}
      disableHeader={true}
      disableFooter={true}
      overrideStyles={overrideStyles}
      onConfirmationComplete={onConfirmationComplete}>
          <Chat selectedUsersId={selectedUsersId} conversation_id={props.conversation_id} />
    </StyledModal>
  );
}
